import React from 'react';

export default function Choices(props) {
  function handleClick(name, text) {
    if (!props.isChecked.includes(name)) {
      props.setIsChecked((prevState) => [...prevState, name]);
      props.setResult((prevState) => prevState + 1);
    } else if (props.isChecked.includes(name)) {
      let filterData = props.isChecked;
      filterData = filterData.filter((item) => item !== name);
      props.setResult((prevState) => prevState - 1);
      props.setIsChecked(filterData);
    }
  }

  return (
    <div className='choices'>
      {props.data.map((item) => (
        <div
          className={`choice ${
            props.isChecked.includes(item.name) ? 'checked' : ''
          }`}
          key={item.name}
          data-id={item.id}
          onClick={() => handleClick(item.name, item.text)}
        >
          <input
            type='checkbox'
            data-id={item.id}
            checked={props.isChecked.includes(item.name)}
            name={item.name}
          />
          <p data-id={item.id}>{item.text}</p>
        </div>
      ))}
    </div>
  );
}
